<footer id="footer" role="contentinfo">
	<div class="container container-wide">
		<div class="row">
			<div class="col-xl col-lg-12 mb-5 d-flex justify-content-center card-box footer1024">
				<div class="card-box">
					<p><img class="img-fluid footer-logo" src="assets/Allison_WHITE-1.png" alt="Allison logo"></p>
					<p>&nbsp; </p>
					<div class="social-icons">
						<a class="fa-2x fab fa-linkedin" href="https://www.linkedin.com/company/allisonoff-highway" target="_blank"></a><a class="fa-2x fab fa-facebook-square" href="https://www.facebook.com/AllisonOffHighway" target="_blank"></a><a class="fa-2x fab fa-twitter-square" href="https://x.com/AllisonTrans" target="_blank"></a><a class="fa-2x fab fa-youtube" href="https://www.youtube.com/@Allison-Off-Highway" target="_blank"></a>
					</div>
				</div>
			</div>
			<div class="col-xl col-lg-2 mb-4 d-flex justify-content-center footer1024">
				<div class="fixed-box">
					<p class="headerFooterMenu">About Allison</p>
					<ul>
						<li><a class="hover-invert" href="https://allisontransmission.com/about-allison/investors" target="_blank" rel="noopener">Investors</a></li>
						<li><a class="hover-invert" href="https://allisonoffhighway.com/category/events/?y=2026" target="_self">Newsroom</a></li>
						<li><a class="hover-invert" href="https://allisontransmission.com/about-allison/privacy-policy" target="_self">Privacy Policy</a></li>
						<li><a class="hover-invert" href="https://allisontransmission.com/about-allison/terms-of-use" target="_self">Terms of Use</a></li>
					</ul>
				</div>
			</div>
			<div class="col-xl col-lg-2 mb-5 pb-5 footer1024">
				<div class="socialmedia-box">
					<p class="headerFooterMenu">&nbsp; </p>
					<ul class="column-separated">
						<li><a class="hover-invert" href="https://allisontransmission.com/about-allison/social-media-policy" target="_self">Social Media Policy</a></li>
						<li><a class="hover-invert" href="https://www.iubenda.com/privacy-policy/52342224/cookie-policy" target="_blank" rel="noopener">Cookies</a></li>
						<li><a class="hover-invert" href="https://allisontransmission.com/about-allison/transparency-in-coverage" target="_self">Transparency in Coverage</a></li>
					</ul>
				</div>
			</div>
			<div class="col-xl col-lg-2 mb-5 pb-5">
				<div class="socialmedia-box">
					<p><a class="headerFooterMenu" href="https://allisontransmission.com/affiliated-companies">Affiliated Companies</a></p>
					<ul>
						<li><a class="hover-invert" href="https://allisontransmission.com/affiliated-companies/allison-ventures" target="_self">Allison Ventures</a></li>
						<li><a class="hover-invert" href="https://allisontransmission.com/affiliated-companies/walker-die-casting" target="_blank" rel="noopener">Walker Die Casting</a></li>
						<li><a class="hover-invert" href="https://allisontransmission.com/affiliated-companies/vantage-power" target="_blank" rel="noopener">Vantage Power</a></li>
					</ul>
				</div>
			</div>

			<div class="col-xl col-lg-2 mb-5 pb-5 h-170">
				<div style="display:flex; flex-direction:column; height:120%;" >
					<p style="margin-top:auto; font-weight:bold;">
						Go to <a href="http://allisontransmission.com" target="_blank" rel="noopener">
							allisontransmission.com
						</a>
					</p>
				</div>
			</div>

		</div>
	</div>
</footer>
